import React, { useState } from 'react';
import moment from 'moment';
import {
    RiFileShield2Line
} from 'react-icons/ri';
import TablePage from '../../../../../components/pages/TablePage';
import Modals from './modal';

export default () => { // eslint-disable-line
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [awb, setAwb] = useState(null);
    const [refresh, setRefresh] = useState(moment().unix());

    const showModal = (row) => {
        setIsModalOpen(true);
        setAwb({
            _id: row?._id,
            mawb_number: row?.mawb_number
        })
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        setAwb(null)
    };

    const columns = [
        {
            selector: (row) => (row?.createdAt && moment(row.createdAt).format('DD-MMM-YYYY')) || '-',
            name: "Tanggal AWB",
            id: 'createdAt'
        },
        {
            selector: (row) => row?.mawb_number,
            name: "Master Awb Number",
            id: 'mawb_number'
        },
        {
            selector: (row) => row?.hawb_number,
            name: "Hawb Number",
            id: 'hawb_number'
        },
        {
            name: "Action Verify",
            id: '_id',
            selector: (row) => {
                return (
                    <>
                        {
                            row?._id === undefined ?
                                <RiFileShield2Line size={20} style={{ color: '#cccc', cursor: 'not-allowed' }} /> :
                                <RiFileShield2Line size={20} style={{ color: 'green', cursor: 'pointer' }} onClick={() => showModal(row)} />
                        }
                    </>
                )
            }
        },
    ]

    return (
        <>
            <Modals isModalOpen={isModalOpen} handleCancel={handleCancel} awb={awb} setRefresh={setRefresh} />
            <TablePage
                title={"Export Verify"}
                url="api/v1/verify/export"
                actionPosition={'first'}
                columns={columns}
                refresh={refresh}
            />
        </>
    )
}